import DOMPurify from 'dompurify';

export class SanitizerService {
  public static sanitizeHtml(input: string): string {
    return DOMPurify.sanitize(input, { USE_PROFILES: { html: true }, ADD_ATTR: ['target'], FORBID_TAGS: ['iframe'] });
  }
}
